import { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import utility from 'src/utils/utility'
import {
    Header, GetStarted, StepCardProps, ResourceItem,
} from 'src/componentv2'
import ConfigurationApiContext from 'src/provider/API/v2/call-service/configuration'
import { BsCheckCircleFill } from 'react-icons/bs'

import completeInstitution from 'src/assets/v2/img/complete_insitution.svg'
import institutionBranding from 'src/assets/v2/img/institution_branding.svg'
import teamInvite from 'src/assets/v2/img/team_invite.svg'
import businessLogic from 'src/assets/v2/img/business_logic.svg'
import arrowIcon from 'src/assets/v2/img/arrow_icon.svg'
import videoGuides from 'src/assets/v2/img/video_guides_icon.svg'
import bookIcon from 'src/assets/v2/img/book_icon.svg'
import supportIcon from 'src/assets/v2/img/support_icon.svg'
import feedbackIcon from 'src/assets/v2/img/feedback_icon.svg'
import arrowIconWhite from 'src/assets/v2/img/arrow_icon_white.svg'

const fitImg = (src: string, alt = '') => (
    <img src={src} alt={alt} style={{ maxWidth: '100%', maxHeight: '100%' }} />
)
const icon = (src: string) => <img src={src} alt="" />

const PAGE_PADDING_X = '10.5rem'

const GetStartedPage = () => {
    const navigate = useNavigate()
    const { getOnboardingChecklist } = useContext(ConfigurationApiContext)
    const [checklist, setChecklist] = useState<any[]>([])

    useEffect(() => {
        (async () => {
            const data = await getOnboardingChecklist()
            if (data) setChecklist(data)
        })()
    }, [])

    const isDone = (key: string) =>
        checklist.find((item) => item.key === key)?.value?.status === 'Completed'

    const doneAction = () => ({
        label: 'Done',
        variant: 'ghost' as const,
        icon: <BsCheckCircleFill style={{ color: '#0D968F' }} />,
        iconPosition: 'right' as const,
        style: {
            fontFamily: 'Gilmer Regular',
            fontWeight: 400,
        },
    })

    const steps: StepCardProps[] = [
        {
            title: 'Complete Institution Profile',
            description: "Establish the institution's identity and communication channels..",
            illustration: fitImg(completeInstitution),
            illustrationBg: '#E7F6F5',
            action: isDone('InstitutionProfile') ? doneAction() : {
                label: 'Start Here',
                variant: 'primary',
                icon: icon(arrowIconWhite),
                iconPosition: 'right',
                style: {
                    fontFamily: 'Gilmer Regular',
                    fontWeight: 400,
                },
            },
            onAction: () => navigate('/dashboardv2/institution-profile'), // Always navigate
        },
        {
            title: 'Set Up Institution Branding',
            description: 'Define how the mobile and internet banking applications will appear to customers',
            illustration: fitImg(institutionBranding),
            illustrationBg: '#F4FBF4',
            action: isDone('InstitutionBranding') ? doneAction() : {
                label: 'Step 2',
                variant: 'ghost',
                icon: icon(arrowIcon),
                iconPosition: 'right',
                style: {
                    fontFamily: 'Gilmer Regular',
                    fontWeight: 400,
                },
            },
            onAction: () => navigate('/dashboardv2/institution-branding'), // Always navigate
        },
        {
            title: 'Invite Team Members',
            description: 'Enable secure collaboration and operational management.',
            illustration: fitImg(teamInvite),
            illustrationBg: '#FDF2EE',
            action: isDone('InviteTeamMembers') ? doneAction() : {
                label: 'Step 3',
                variant: 'ghost',
                icon: icon(arrowIcon),
                iconPosition: 'right',
                style: {
                    fontFamily: 'Gilmer Regular',
                    fontWeight: 400,
                },
            },
            onAction: () => navigate('/dashboardv2/invite-team'), // Always navigate
        },
        {
            title: 'Setup Business Logic',
            description: 'Configure operational rules that control customer transactions and account.',
            illustration: fitImg(businessLogic),
            illustrationBg: '#EFF4FF',
            action: isDone('BusinessLogic') ? doneAction() : {
                label: 'Step 4',
                variant: 'ghost',
                icon: icon(arrowIcon),
                iconPosition: 'right',
                style: {
                    fontFamily: 'Gilmer Regular',
                    fontWeight: 400,
                },
            },
            onAction: () => navigate('/dashboardv2/business-logic'), // Always navigate
        },
    ]

    const completed = ['InstitutionProfile', 'InstitutionBranding', 'InviteTeamMembers', 'BusinessLogic']
        .filter(isDone).length

    const resources: ResourceItem[] = [
        { label: 'Video Guides', icon: icon(videoGuides), onClick: () => {} },
        { label: 'Help Articles', icon: icon(bookIcon), onClick: () => {} },
        { label: 'Contact support', icon: icon(supportIcon), onClick: () => {} },
        { label: 'Share Feedback', icon: icon(feedbackIcon), onClick: () => {} },
    ]

    return (
        <>
            <Header sticky initials="QO" />
            <div style={{ padding: `0 ${PAGE_PADDING_X}` }}>
                <GetStarted
                    title="Get Started"
                    subtitle="Complete these essential steps to configure your support environment."
                    progress={{ value: completed, total: steps.length }}
                    steps={steps}
                    resources={resources}
                />
            </div>
        </>
    )
}

export default utility.routeData('get-started', 'Get Started', <GetStartedPage />)